import { render, staticRenderFns } from "./IconMarkerWithShadow.vue?vue&type=template&id=2bcb5ae2&scoped=true&"
import script from "./IconMarkerWithShadow.vue?vue&type=script&lang=js&"
export * from "./IconMarkerWithShadow.vue?vue&type=script&lang=js&"
import style0 from "./IconMarkerWithShadow.vue?vue&type=style&index=0&id=2bcb5ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb5ae2",
  null
  
)

export default component.exports